// @mui
import { RadioGroup } from '@mui/material';

//
import SvgColor from '../../svg-color';
import { useSettingsContext } from '../SettingsContext';
import { MaskControl, StyledCard, StyledWrap } from '../styles';

// ----------------------------------------------------------------------

const OPTIONS = ['light', 'dark'] as const;

const ModeOptions = () => {
  const { onChangeMode, themeMode } = useSettingsContext();

  return (
    <RadioGroup name="themeMode" onChange={onChangeMode} value={themeMode}>
      <StyledWrap>
        {OPTIONS.map((mode) => (
          <StyledCard key={mode} selected={themeMode === mode}>
            <SvgColor
              src={`/assets/icons/setting/${
                mode === 'light' ? 'ic_sun' : 'ic_moon'
              }.svg`}
            />

            <MaskControl value={mode} />
          </StyledCard>
        ))}
      </StyledWrap>
    </RadioGroup>
  );
};

export default ModeOptions;
